import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { ContentSection } from './components/ContentSection';
import { BonusSection } from './components/BonusSection';
import { TransformationSection } from './components/TransformationSection';
import { Testimonials } from './components/Testimonials';
import { OfferSection } from './components/OfferSection';
import { IdentificationSection } from './components/IdentificationSection';
import { UrgencySection } from './components/UrgencySection';
import { FinalCTA } from './components/FinalCTA';
import { SocialProofPopup } from './components/SocialProofPopup';
import { FloatingMobileCTA } from './components/FloatingMobileCTA';
export function App() {
  return <div className="min-h-screen bg-brand-cream font-inter overflow-x-hidden" data-id="element-0">
      <Hero data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <SolutionSection data-id="element-3" />
      <ContentSection data-id="element-4" />
      <BonusSection data-id="element-5" />
      <TransformationSection data-id="element-6" />
      <Testimonials data-id="element-7" />
      <OfferSection data-id="element-8" />
      <IdentificationSection data-id="element-9" />
      <UrgencySection data-id="element-10" />
      <FinalCTA data-id="element-11" />

      <SocialProofPopup data-id="element-12" />
      <FloatingMobileCTA data-id="element-13" />
    </div>;
}